"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
exports.__esModule = true;
exports.keystringify = exports.getMissingKeys = exports.createMappedReducer = exports.DEFAULT_LOADABLE = void 0;
var _freeze = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/freeze"));
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _sort = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/sort"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));
/**
 * The default core peice of data returned (or expected
 * to be returned) from some given API.
 */
var DEFAULT_LOADABLE = exports.DEFAULT_LOADABLE = (0, _freeze["default"])({
  loaded: false,
  loading: false,
  notFound: false,
  error: false
});

/**
 * Creates a reducer that uses the given hash of (name:reducer) pairs
 * to determine how to reduce the function.
 *
 * @example
 * const hash = { @@SOME_ACTION: function () { // stuff } };
 * const reducer = createMappedReducer(map, {});
 * reducer({}, { type: @@SOME_ACTION });
 * reducer({}, { type: @@SOME_OTHER_ACTION }); // noop;
 *
 * @param {Object}
 * @param {Mixed}
 *
 * @returns {Function}
 */
var createMappedReducer = exports.createMappedReducer = function createMappedReducer(hash, defaultState) {
  /**
   * @param {Mixed}
   * @param {Object}
   *
   * @returns {Mixed}
   */
  return function (state, action) {
    if (state === void 0) {
      state = defaultState;
    }
    if (action === void 0) {
      action = {
        type: ''
      };
    }
    var _action = action,
      type = _action.type;
    if (!hash[type]) return state;
    return hash[type](state, action);
  };
};

/**
 * Determines which keys are missing in the provided
 * data object.
 *
 * @param {Array}
 * @param {Object}
 *
 * @returns {Array}
 */
var getMissingKeys = exports.getMissingKeys = function getMissingKeys(keys, data) {
  return (0, _reduce["default"])(keys).call(keys, function (previous, key) {
    if (data[key]) return previous;
    previous.push(key);
    return previous;
  }, []);
};

/**
 * Serializes search parameters in order to create a unique
 * deterministic key that can be used to index this query in
 * the store. We can't just JSON.stringify as the iteration
 * order of objects is not guarenteed, nor is the ordering
 * of arrays in parameters consistent.
 *
 * @param {Object}
 *
 * @returns {String}
 */
var keystringify = exports.keystringify = function () {
  /**
   * Recursively sorts the keys in a collection.
   *
   * @param {Object|Array}
   * @param {string|undefined}
   *
   * @returns {Object|Array}
   */
  function recurse(collection, key) {
    if ((0, _isArray["default"])(collection)) {
      var _context;
      var copy = (0, _concat["default"])(_context = []).call(_context, collection);

      // the sort order is meaningful, should not reorder it
      if (key !== 'sort') (0, _sort["default"])(copy).call(copy);
      return (0, _map["default"])(copy).call(copy, function (v) {
        return recurse(v, undefined);
      });
    }
    if (collection && typeof collection === 'object') {
      var _context2, _context3;
      return (0, _reduce["default"])(_context2 = (0, _sort["default"])(_context3 = (0, _keys["default"])(collection)).call(_context3)).call(_context2, function (previous, k) {
        previous[k] = recurse(collection[k], k);
        return previous;
      }, {});
    }

    // TODO: Fails silently on other types, ESLint requires a return.
    return collection;
  }

  /**
   * Serialises a sorted object, the output
   * will be deterministic.
   *
   * @param {Object|Array}
   *
   * @returns {String}
   */
  return function (collection) {
    return (0, _stringify["default"])(recurse(collection, undefined));
  };
}();